import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { PermissionGroupAmbitItemMaintenanceDto } from './PermissionGroupAmbitItemMaintenanceDto';
import { PermissionGroupAmbitListMaintenanceDto } from './PermissionGroupAmbitListMaintenanceDto';

@Injectable()
export class PermissionGroupAmbitSubMaintenanceController extends BaseSubMaintenanceController<PermissionGroupAmbitListMaintenanceDto, PermissionGroupAmbitItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "system/securityandnotifications/permissiongroup/ambit");
    }

    public getResourceRoot(): string {
        return "PERMISSION.GROUP.AMBIT";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/securityandnotifications/permissiongroup/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}